var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-header-card',{attrs:{"header":_vm.header,"rows":_vm.rows},scopedSlots:_vm._u([{key:"parentId",fn:function(){return [_c('a',{staticClass:"btn-link",attrs:{"href":`#/managed-lists/${_vm.managedList.parent_id}`}},[_vm._v("\n      "+_vm._s(_vm.managedList.parent 
        ? _vm.managedList.parent.description 
        : _vm.managedList.parent_id)+"\n    ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }